<template>
  <v-col v-if="data.length" cols="12" class="text-center caption error--text">
    <div v-if="!single">
      <div v-for="(error, index) in data" :key="index">
        {{ error }}
      </div>
    </div>
    <div v-else>
      {{ data }}
    </div>
  </v-col>
</template>

<script>
export default {
  name: 'GGError',
  props: {
    single: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Array, String],
      required: true
    }
  },
}
</script>
